import React from "react";
import { Flex, Box } from "@chakra-ui/react";
import { FillImage } from "components/images";
import { MotionBox } from "ui/chakra-motion";
import image from "../../../../public/assets/platform/customer-studio/journeys.png";

export function JourneysAnimation({ delay = 1 }: { delay?: number }) {
  return (
    <Flex
      align="center"
      bgGradient="linear(30deg, new.blue.150 60%, white 180%)"
      boxSize="100%"
      py={{ base: "big", xl: "huge" }}
      pos="relative"
    >
      <MotionBox
        display="flex"
        alignItems="center"
        pos="absolute"
        inset={0}
        left={0}
        width={{ base: "180%", lg: "260%", xl: "308%" }}
        maxHeight={{ base: "65%", sm: "62%", lg: "68%", xl: "74%" }}
        my="auto"
        pt="big"
        initial={{ x: "-4%", scale: 0.9 }}
        whileInView={{
          x: "-24%",
          scale: 1,
          transition: { delay, duration: 7, ease: [0.5, 0, 0.8, 1] },
        }}
      >
        <Box boxSize="100%" pos="relative">
          <FillImage
            priority
            src={image}
            alt="Journeys"
            style={{ objectFit: "contain", objectPosition: "left center" }}
          />
        </Box>
      </MotionBox>
    </Flex>
  );
}
